import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PlayBlackIcon from "../../../../assets/icons/play-black.svg";
import PlusWhiteIcon from "../../../../assets/icons/plus-white.svg";
import "./LastLiveReplaySection.less";

interface LastLiveReplaySectionProps {
  thumbnail: string;
  creatorName: string;
  liveDescription: string;
  tags: string[];
  replayId: string;
  showSubscribeButton?: boolean;
  isSubscribed?: boolean;
  creatorId?: string;
}

const LastLiveReplaySection: React.FC<LastLiveReplaySectionProps> = ({
  thumbnail,
  creatorName,
  tags,
  liveDescription,
  replayId,
  showSubscribeButton = true,
  isSubscribed = false,
  creatorId,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handlePlayClick = () => {
    navigate(`/common/live-replays/${replayId}`, { state: { thumbnail } });
  };

  const handleSubscribeClick = () => {
    if (creatorId) {
      navigate(`/common/subscribe/${creatorId}`);
    }
  };

  return (
    <div className="last-live-replay-section">
      <div className="live-thumbnail-container" style={{ backgroundImage: `url(${thumbnail})` }}>
        <div className="live-overlay-content">
          <div className="creator-name">{creatorName}</div>
          {/* <div className="creator-tags">
            {tags.map((tag, index) => (
              <span key={index}>
                {tag}
                {index < tags.length - 1 && <span className="tag-separator">•</span>}
              </span>
            ))}
          </div> */}
          {liveDescription && <div className="last-live-replay-description">{liveDescription}</div>}
          <div className="action-buttons">
            <button className="play-button" onClick={handlePlayClick}>
              <img src={PlayBlackIcon} alt="play" width={24} />
              <span>{t("play-button")}</span>
            </button>
            {showSubscribeButton && !isSubscribed && (
              <button className="subscribe-button" onClick={handleSubscribeClick}>
                <img src={PlusWhiteIcon} alt="plus" width={16} />
                <span>{t("subscribe-button")}</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LastLiveReplaySection;
